import React, { useMemo, useCallback, useState, useEffect } from 'react';
import _ from 'lodash';

import { makeStyles, Container, Grid, Paper } from '@material-ui/core';
import { injectIntl } from 'react-intl';

import BreadCrumb from 'app/components/BreadCrumb';
import SurveyRegistration from 'app/components/ServicesForms/Survey';

import { useSelector, useDispatch } from 'react-redux';
import { FormServiceContext } from 'app/utils/contexts';
import { preparePayload } from 'app/utils/forms/functions';
import { fetchSaveRequest, updateRequestDetails } from 'app/store/slices/requests';

import { showLoading, hideLoading } from 'app/store/slices/settings';
import { extractFileFromJson, setVehicles } from 'app/store/slices/forms';
import notification from 'app/config/notification';
import withRequestInitiation from 'app/components/Hoc/withRequestInitiation';
import surveyEndpoint from 'app/api/services/surveyEndpoint';
import alertsEndpoint from 'app/api/services/alertsEndpoint';
import vehiclesEndpoint from 'app/api/services/vehiclesEndpoint';

import { errorHandler } from 'app/utils/errorHandler';
import { setVehiclePlateByCompany } from 'app/store/slices/vehicle';
import { generatePath, useHistory } from 'react-router-dom';
import { surveyVehiclePayload } from 'app/utils/forms/payloadsStruture';
import { validateSurveyRequest } from 'app/utils/forms/validators/survey';

import { SERVICES_CODES, SERVICES_PROPERTIES } from 'app/config/services';
import { URLS } from 'app/config/urls';
import { STATUS_CODES } from 'app/config/status';

import styles from './styles';
const useStyles = makeStyles(styles);

function Survey(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();

  const {
    intl,
    loadingDocuments,
    setLoadingDocuments,
    canEdit,
    editing,
    resetAndGo,
    onCancel,
    validateForm,
    breadCrumb,
    rightInfo,
    handleOnBack,
  } = props;

  const service = useSelector(state => state.services.details);
  const request = useSelector(state => state.requests.details);
  const activeCompany = useSelector(state => state.company.activeCompany);
  const documentsStore = useSelector(state => state.services.documents);
  const registrationUserInfo = useSelector(state => state.auth.registrationInfo);
  const userAdmin = useSelector(state => state.auth.userAdmin);
  const vehicles = useSelector(state => state.forms.vehicles);

  const [canEditVehicle] = useState(false);
  const [loadingPlates, setLoadingPlates] = useState(false);
  const [initialValues, setInitialValues] = useState(
    SERVICES_PROPERTIES[service.cdServico]?.formInitialValues || {}
  );

  useEffect(() => {
    const init = async () => {
      if (editing) {
        const parsed = JSON.parse(request.jsonSolicitacao);
        // if (request.cdSituacao && request.cdSituacao !== STATUS_CODES.EM_CONSTRUCAO) {
        //   const response = await surveyEndpoint.getSurveyByRequest(request.cdSolicitacao);
        //   if (response?.status === 200 && response.data) {
        //     const surv = response.data;
        //     const jsonVehicles = surv.vistoriaVeiculos.map(v => {
        //       return v.veiculo;
        //     });
        //     dispatch(setVehicles(jsonVehicles));
        //   }
        // } else {
        if (parsed.vistoriaVeiculos) {
          const jsonVehicles = parsed.vistoriaVeiculos.map(v => {
            return v.veiculo;
          });
          dispatch(setVehicles(jsonVehicles));
        }
        // }
        setInitialValues(parsed);
      }
    };
    init();
  }, [dispatch, editing, request, service.cdServico]);

  // Busca os primeiros veiculos
  useEffect(() => {
    const init = async () => {
      setLoadingPlates(true);
      try {
        let response = [];
        response = await vehiclesEndpoint.getVehiclesPlatesByCompany();
        if (response?.data) {
          dispatch(setVehiclePlateByCompany(response.data));
        }
        if (!response.data || response.data.length <= 0) {
          if (!request.situacao) {
            notification(
              intl.formatMessage({ id: 'MESSAGES.SERVICE.FORMS.SURVEY_NO_VEHICLES_FOUND' }),
              {
                toastId: 'MESSAGES.SERVICE.FORMS.SURVEY_NO_VEHICLES_FOUND',
                type: 'error',
              }
            );
            history.push(generatePath(URLS.SERVICES));
          }
        }
      } catch (error) {
        errorHandler(error.response?.status, error.response?.data?.message);
      }
      setLoadingPlates(false);
    };
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  const onSave = useCallback(
    async (values, fromSubmit, isInternalForm) => {
      if (!canEdit) {
        if (service.cdServico !== SERVICES_CODES.EXCLUSAO_VEICULOS) {
          return;
        } else {
          if (request.situacao && !request.situacao?.boEdicaoPortalExterno) return;
        }
      }
      const valuesCopy = { ...values };
      let error = 0;
      valuesCopy.vistoriaVeiculos = vehicles.map(v => {
        let temp = _.cloneDeep(surveyVehiclePayload);
        const found = _.find(initialValues.vistoriaVeiculos, ['cdVeiculo', v.cdVeiculo]);
        if (found) {
          temp = _.cloneDeep(found);
        } else {
          temp.cdVeiculo = v.cdVeiculo;
        }
        temp.veiculo = v;

        temp.documentos = v.documentos || [];
        if (temp.documentos.length === 0) {
          error++;
        }
        return temp;
      });

      if (error > 0) {
        notification(intl.formatMessage({ id: 'MESSAGES.SERVICE.FORMS.MISSING_VEHICLES_DOCS' }), {
          toastId: 'MISSING_VEHICLES_DOCS',
          type: 'warning',
        });
        return false;
      }

      if (!await validateSurveyRequest({ values: valuesCopy, vehicles, intl, isInternalForm })) {
        return;
      }

      const documentsObject = {
        store: documentsStore,
        files: valuesCopy.documentos,
      };

      if (request?.situacao) valuesCopy.situacao = request.situacao;

      let dataToPayload = { cdServico: service.cdServico };
      if (request && request.cdServico) dataToPayload = { ...request };

      const preparedPayload = preparePayload({
        values: valuesCopy,
        documents: documentsObject,
        params: dataToPayload,
        activeCompany,
        userAdmin,
        registrationUserInfo
      });

      dispatch(showLoading());

      let showMessage = false;
      let response = false;
      if (!fromSubmit) showMessage = true;
      try {
        response = await fetchSaveRequest({
          isFormData: true,
          preparedPayload,
          dispatch,
          intl,
          showMessage,
          cdService: service.cdServico
        });

        if (response?.status === 200 && response?.data) {
          const req = _.cloneDeep(response.data);
          if (req.jsonSolicitacao) {
            const responseJson = JSON.parse(req.jsonSolicitacao);
            if (responseJson.vistoriaVeiculos && responseJson.vistoriaVeiculos.length > 0) {
              const vistoriaVeiculos = responseJson.vistoriaVeiculos.map(vv => {
                const temp = _.cloneDeep(vv);
                temp.veiculo.documentos = temp.documentos;
                return temp;
              });
              responseJson.vistoriaVeiculos = vistoriaVeiculos;
            }
            await dispatch(extractFileFromJson(responseJson.documentos));
            req.jsonSolicitacao = JSON.stringify(responseJson);
          }

          await dispatch(updateRequestDetails(req));
        }
      } catch (error) {
        errorHandler(error.response?.status, error.response?.data?.message);
      }

      if (!fromSubmit) dispatch(hideLoading());
      return response;
    },
    [
      activeCompany,
      canEdit,
      dispatch,
      documentsStore,
      initialValues.vistoriaVeiculos,
      intl,
      registrationUserInfo,
      request,
      service.cdServico,
      userAdmin,
      vehicles,
    ]
  );

  const onSubmit = useCallback(
    async values => {
      if (!canEdit) {
        if (service.cdServico !== SERVICES_CODES.INATIVACAO_CADASTRAL) {
          return;
        } else {
          if (request.situacao && !request.situacao?.boEdicaoPortalExterno) return;
        }
      }

      const currentStatusCode = request.cdSituacao;

      if ((documentsStore.length > 0 && values.documentos?.length === 0) || vehicles.length === 0) {
        notification(
          intl.formatMessage({ id: 'MESSAGES.SERVICE.FORMS.MISSING_MANDATORY_VEHICLES' }),
          {
            toastId: 'MISSING_MANDATORY_VEHICLES',
            type: 'warning',
          }
        );
        return false;
      }

      const responseSave = await onSave(values, true);

      if (responseSave && responseSave.status === 200) {
        try {
          const response = await surveyEndpoint.finishRequest(responseSave.data.cdSolicitacao);

          if (response.status === 200) {
            notification(
              intl.formatMessage({ id: 'MESSAGES.SERVICE.FORMS.SUCCESSFUL_FINISHED_REQUEST' }),
              { toastId: 'SUCCESSFUL_FINISHED_REQUEST', type: 'success' }
            );

            if (currentStatusCode === STATUS_CODES.AGUARDANDO_RESOLUCAO_PENDENCIAS) {
              await alertsEndpoint.deleteAlert({ cdSolicitacao: request.cdSolicitacao });
            }
          }

          resetAndGo();
        } catch (error) {
          errorHandler(error.response?.status, error.response?.data?.message);
        }
      }

      dispatch(hideLoading());
    },
    [
      canEdit,
      dispatch,
      documentsStore.length,
      intl,
      onSave,
      request.cdSituacao,
      request.cdSolicitacao,
      request.situacao,
      resetAndGo,
      service.cdServico,
      vehicles.length,
    ]
  );

  const contextProvider = useMemo(() => {
    return {
      loadingDocuments,
      setLoadingDocuments,
      validateForm,
      onSubmit,
      onSave,
      onCancel,
      initialValues,
      validationSchema: SERVICES_PROPERTIES[service.cdServico]
        ? SERVICES_PROPERTIES[service.cdServico].validationSchema
        : {},
      validateOnSave: true,
      canEdit,
      canEditVehicle,
      loadingPlates: loadingPlates,
    };
  }, [
    loadingDocuments,
    setLoadingDocuments,
    validateForm,
    onSubmit,
    onSave,
    onCancel,
    initialValues,
    service.cdServico,
    canEdit,
    canEditVehicle,
    loadingPlates,
  ]);

  return (
    <Container>
      <BreadCrumb onBack={handleOnBack} breadCrumb={breadCrumb} rightInfo={rightInfo} />
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Paper className={classes.container} elevation={3}>
            <FormServiceContext.Provider value={contextProvider}>
              <SurveyRegistration {...props} />
            </FormServiceContext.Provider>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
}

export default injectIntl(withRequestInitiation(Survey));
